import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import Newsletter from '../global/Newsletter';
import { PageFlow } from '../shared/SectionSurface';
import DeliveryDetails from './DeliveryDetails';
import { OG_PREVIEW } from '../../../content/staticAssets';
import { getSeoForPath } from '../../../content/seoMeta';

const deliverySeo = getSeoForPath('/delivery');

function Delivery() {
  return (
    <div>
      <Helmet>
        <title>{deliverySeo.title}</title>
        <meta name="description" content={deliverySeo.description} />
        <meta
          name="keywords"
          content="agile delivery, Azure DevOps, sprints, backlog, boards, pipelines, CI/CD, releases, governed analytics"
        />
        <meta property="og:title" content={deliverySeo.title} />
        <meta property="og:description" content={deliverySeo.description} />
        <meta property="og:image" content={OG_PREVIEW} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://www.myorglab.com/delivery" />
      </Helmet>
      <Navbar />
      <PageFlow>
        <DeliveryDetails />
      </PageFlow>
      <Newsletter />
      <Footer />
    </div>
  );
}

export default Delivery;
